import jwtService from './jwtService';
import { hideMessage, showMessage } from 'app/store/actions';
import { setUserData } from './user.actions';
import decode from 'jwt-decode';
import { API_BASE_URL } from '@config';
import axios from 'axios';

export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const setLoginSuccess = () => ({
	type: SET_LOGIN_SUCCESS
});

export const SET_REGISTER_SUCCESS = 'SET_REGISTER_SUCCESS';
export const setRegisterSuccess = () => ({
	type: SET_REGISTER_SUCCESS
});

export const SET_ERROR = 'SET_ERROR';
export const setError = error => ({
	type: SET_ERROR,
	payload: error
});

export const CLEAR_ERROR = 'CLEAR_ERROR ';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const CLEAR_AUTH = 'CLEAR_AUTH ';
export const clearAuth = () => ({
	type: CLEAR_AUTH
});

export const SET_ACTIVE_LDAP_SERVERS = 'GET_ACTIVE_LDAP_SERVERS';
export const setActiveLdapServers = servers => ({
	type: SET_ACTIVE_LDAP_SERVERS,
	payload: servers
});

export const SET_ACTIVE_OIDC_PROVIDERS = 'SET_ACTIVE_OIDC_PROVIDERS';
export const setActiveOidcProviders = (providers) => ({
	type: SET_ACTIVE_OIDC_PROVIDERS,
	payload: providers
});

export const getActiveOidcProviders = () => (dispatch) => {
	const url = `${API_BASE_URL}/api/openid-config/active`;
	return axios
		.get(url)
		.then(res => dispatch(setActiveOidcProviders(res.data)))
		.catch(err => dispatch(setError({ ...err?.response?.data, type: 'modal' })));
};

export const getActiveLdapServers = () => (dispatch) => {
	const url = `${API_BASE_URL}/api/ldap/servers/active`;
	const request = axios.get(url);
	return request
		.then(res => dispatch(setActiveLdapServers(res.data)))
		.catch(err => dispatch(setError({ ...err.data, type: 'modal' })));
};

export const submitLocalLogin = data => dispatch => {
	dispatch(showMessage({ message: 'Authenticating User' }));

	return jwtService
		.signInForLocal(data)
		.then(token => decode(token))
		.then(({ user }) => {
			dispatch(setUserData(user));
			dispatch(setLoginSuccess());
		})
		.catch(err => {
			let errObj = {};
			const status = err.status;

			if (status === 401) {
				errObj.code = status;
				errObj.message = 'Authentication Error';
				return dispatch(setError({ ...errObj, type: 'form' }));
			}

			// Show modal for org-related blocking errors (403)
			if (status === 403) {
				errObj = { ...err.data };
				dispatch(hideMessage());
				return dispatch(setError({ ...errObj, type: 'modal' }));
			}

			errObj = { ...err.data };
			return dispatch(setError({ ...errObj, type: 'form' }));
		});
};

export const submitLdapLogin = data => dispatch => {
	dispatch(showMessage({ message: 'Authenticating User' }));

	return jwtService
		.signInForLdap(data)
		.then(token => decode(token))
		.then(({ user }) => {
			dispatch(setUserData(user));
			dispatch(setLoginSuccess());
		})
		.catch(err => {
			let errObj = {};
			const status = err.response?.status;
			const data = err.response?.data;
			if (status === 401) {
				errObj.code = status;
				errObj.message = data.message ? data.message : 'Authentication Error.';
				dispatch(hideMessage());
				return dispatch(setError({ ...errObj, type: 'modal' }));
			}

			// Show modal for org-related blocking errors (403)
			if (status === 403) {
				errObj = { ...data };
				dispatch(hideMessage());
				return dispatch(setError({ ...errObj, type: 'modal' }));
			}

			errObj = { ...data };
			return dispatch(setError({ ...errObj, type: 'form' }));
		});

};

export const submitLoginForTrainingSession = (fullName, sessionCode, participantEmail) => dispatch => {
	dispatch(showMessage({ message: 'Authenticating User' }));
	return jwtService
		.signInForTrainingSession(fullName, sessionCode, participantEmail)
		.then(token => {
			const decoded = decode(token);
			return decoded;
		})
		.then(({ user }) => {
			dispatch(setUserData(user));
			dispatch(setLoginSuccess());
		})
		.catch(err => {
			let errObj = {};
			if (err.status === 401) {
				errObj.code = err.status;
				errObj.message = 'Authentication Error';
			} else {
				errObj = { ...err.data };
			}
			return dispatch(setError({ ...errObj, type: 'form' }));
		});
}

export const submitRegister = userData => dispatch => {
	dispatch(showMessage({ message: 'Creating User' }));
	return jwtService
		.createUser(userData)
		.then(token => {
			if (token) {
				const { user } = decode(token);
				dispatch(setUserData(user));
			}
			dispatch(setRegisterSuccess());
		})
		.catch(err => dispatch(setError({ ...err.data, type: 'form' })));
};

export const submitRegisterByAdmin = userData => dispatch => {
	dispatch(showMessage({ message: 'Creating User' }));
	return jwtService
		.createUserByAdmin(userData)
		.then(_ => {
			dispatch(showMessage({ message: `User created successfully` }));
			return true;
		})
		.catch(err => {
			dispatch(setError({ ...err.data, type: 'form' }));
			return false;
		});
};

export const createUser = userData => dispatch => {
	dispatch(showMessage({ message: 'Creating User' }));
	return axios
		.post(`${API_BASE_URL}/api/users/create`, userData)
		.then(() => {
			dispatch(showMessage({ message: 'User created successfully' }));
			return true;
		})
		.catch(err => {
			const errorData = err.response?.data || err.data || {};
			dispatch(setError({ ...errorData, type: 'form' }));
			return false;
		});
};
